import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Product } from '../shared/model/ui/product';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { CmTooltip, ContentType } from '../shared/model/cm/managed-content.model';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@Component({
selector: 'app-disability-radio',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './disability-radio.component.html',
  styleUrls: ['./disability-radio.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DisabilityRadioComponent implements OnInit, OnDestroy, AfterViewInit  {
  @Input() parentForm: FormGroup;
  @Input() product: Product;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public innerWidth: number = window.innerWidth;
  public colaToolTipPosition: string = 'top';

  public colaToolTipName: string;
  public colaToolTipDescription: string;
  public colaToolTip: CmTooltip;
  public colaToolTipTitle: string;

  constructor(private fb: FormBuilder,
    private cmService: ManagedContentService,
    public formControlUtilitiesService: FormControlUtilitiesService
  ) { }

  ngOnInit(): void {

    if(this.parentForm){
      this.parentForm.addControl(this.product.key + '_subProduct', this.fb.control('', [Validators.required]));
    }

    this.colaToolTipName = 'eeoi-tooltip-cola';
    this.colaToolTip = this.cmService.getContentById(ContentType.TOOLTIP, this.colaToolTipName);
    this.colaToolTipTitle = this.colaToolTip.title;
    this.colaToolTipDescription = this.colaToolTip.plainText;

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      this.innerWidth = window.innerWidth;
      this.changeTooltipPosition();
    });

  }//end ngOnInit

  ngOnDestroy(): void {
    if(this.parentForm){
      this.parentForm.removeControl(this.product.key + '_subProduct');
    }
  }

  ngAfterViewInit(){
    this.innerWidth = window.innerWidth;
    this.changeTooltipPosition();
  }

  changeTooltipPosition(){
    if(this.innerWidth < 645){
      this.colaToolTipPosition = 'left';
    } else {
      this.colaToolTipPosition = 'top';
    }
  }

  subProductRadioSelected(key: string, value: string){
    this.parentForm.get(key).setValue(value);
    this.parentForm.get(key).markAsTouched();
    this.parentForm.updateValueAndValidity();
  }

}